export class DirectionalList<T> {
  private readonly itemsFromTargetToSource: T[];
  constructor(private readonly itemsFromSourceToTarget: T[]) {
    this.itemsFromTargetToSource = this.itemsFromSourceToTarget.toReversed();
  }
  public get length(): number {
    return this.itemsFromSourceToTarget.length;
  }

  public get fromSourceToTarget(): T[] {
    return this.itemsFromSourceToTarget;
  }

  public get fromTargetToSource(): T[] {
    return this.itemsFromTargetToSource;
  }
}
